import React, { useState, useRef } from 'react'
import styles from './styles'
import { Typography, withStyles } from '@material-ui/core'
import content from './content'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Controller, Pagination } from 'swiper/modules'
import { CoreButton } from 'src/components/core'
import Lottie from 'react-lottie'
import onboardingData from 'src/lotties/onboarding-1.json'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/pagination'

const OnboardingInformation = props => {
  const { pageView, setPageView, handlePageView, name, classes } = props
  const [controlledSwiper, setControlledSwiper] = useState(null)
  const swiperRef = useRef(null)

  const goNext = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideNext()
    }
  }

  const goPrev = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slidePrev()
    }
  }
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: onboardingData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }
  return (
    <div className={classes.onBoardingRoot}>
      <Swiper
        // Install modules
        ref={swiperRef}
        //pagination={{ clickable: true }}
        modules={[Pagination, Controller]}
        spaceBetween={50}
        slidesPerView={1}
        onSlideChange={swiper => setPageView(swiper.activeIndex + 1)}
        scrollbar={{ draggable: true }}
        onSwiper={setControlledSwiper}
        controller={{ control: controlledSwiper }}
        style={{
          maxWidth: '520px',
          width: '100%',
          marginRight: '20px',
          marginLeft: '0px',
        }}
      >
        <SwiperSlide>
          <div
            className={classes.onBoardingRoot_leftSide}
            style={{
              backgroundImage: `url(/assets/onboarding-1.png)`,
            }}
          ></div>
        </SwiperSlide>
        <SwiperSlide>
          <div
            className={classes.onBoardingRoot_leftSide}
            style={{
              backgroundImage: `url(/assets/onboarding-2.png)`,
            }}
          ></div>
        </SwiperSlide>
        <SwiperSlide>
          <div
            className={classes.onBoardingRoot_leftSide}
            style={{
              backgroundImage: `url(/assets/onboarding-3.png)`,
            }}
          ></div>
        </SwiperSlide>

        {/* ... */}
      </Swiper>

      <div className={classes.onBoardingRoot_rightSide}>
        <div className={classes.onBoardingRoot_rightSide_text}>
          <Typography
            className={classes.onBoardingHeader}
            style={{
              backgroundColor:
                content[pageView - 1].headerColor !== 'none'
                  ? content[pageView - 1].headerColor
                  : 'transparent',
              color: '#212B36',
            }}
          >
            {content[pageView - 1].header}
          </Typography>

          <Typography
            className={classes.onBoardingExplanation}
            dangerouslySetInnerHTML={{
              __html: content[pageView - 1].explanation,
            }}
          />
          <div className={classes.onBoarding_FX}></div>
          <div className={classes.onBoarding_buttonGroup}>
            <CoreButton
              variant="contained"
              size="large"
              fullWidth
              onClick={() => {
                handlePageView()
                goNext()
              }}
            >
              {content[pageView - 1].buttonText}
            </CoreButton>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withStyles(styles)(OnboardingInformation)
